export default [
    {
        date: "June 2022 - December 2023",
        institution: "codeTribe",
        location: "Pretoria, South Africa",
        course: "Software Development",
        description:
          "This course was offered by mLab southern Africa under codeTribe program.I was introduced to programming languages and technologies not limited to HTML5, CSS3,JavaScript, React and React Native"
      },
    {
      date: "April 2022 - September 2022",
      institution: "Mtn Business App Academy",
      location: "Remote",
      course: "Mobile App development",
      description:
      "This course was offered by I.T Varsity in partnership with MTN Business and MICTSETA. I was introduced to languages and technologies not limited to Dart, Flutter, JavaScript, React Native and Firebase"
    },
  ];
  